module.exports = __webpack_public_path__ + "img/loop.f82cfbd9.png";